import type { SignatureType } from './schemas'

export const SIGNATURE_TYPE_KO = {
  ARITHMETIC: '연산',
  BASIC: '유형서',
  CONCEPT: '개념서',
  HIGH: '심화유형서',
  SCHOOL_TEST: '내신대비',
  VACATION_BOOTCAMP: '방학특강',
  CONCEPT_UNIT_LIGHT: '개념유형라이트',
  N_PROBLEM: 'N제',
} as const satisfies Record<SignatureType, string>
export type SignatureTypeKo = (typeof SIGNATURE_TYPE_KO)[SignatureType]
